import type { PageList } from '@omnia/ui/src/lib'
import { lazy } from 'react'
import type { MemberSubPages, PagesEnum } from '../common/services/models/pages'
import { HomePage } from './home/HomePage'

export const Pages: PageList<PagesEnum, MemberSubPages> = {
    Home: {
        component: HomePage,
        urls: ['/'],
    },
    Generic: {
        component: lazy(() => import('./generic/GenericPage')),
        urls: ['/'],
    },
    Cinemas: {
        component: lazy(() => import('./cinemas/CinemasPage')),
        urls: ['/'],
    },
    Cinema: {
        component: lazy(() => import('./cinema/CinemaPage')),
        urls: ['/'],
    },
    Films: {
        component: lazy(() => import('./films/FilmsPage')),
        urls: ['/'],
    },
    Events: {
        component: lazy(() => import('./events/EventsPage')),
        urls: ['/'],
    },
    FilmDetails: {
        component: lazy(() => import('./filmDetails/FilmDetailsPage')),
        urls: ['/'],
        parent: 'Films',
        params: ['filmName', 'filmId'],
        customAlias: 'filmDetails',
    },
    EventDetails: {
        component: lazy(() => import('./eventDetails/EventDetailsPage')),
        urls: ['/'],
        parent: 'Events',
        params: ['eventName', 'eventId'],
        customAlias: 'eventDetails',
    },
    SignIn: {
        component: lazy(() => import('./signIn/SignInPage')),
        urls: ['/'],
    },
    SignUp: {
        component: lazy(() => import('./signUp/SignUpPage')),
        urls: ['/'],
    },
    PasswordReset: {
        component: lazy(() => import('./passwordReset/PasswordResetPage')),
        urls: ['/'],
    },
    Member: {
        component: lazy(() => import('./member/MemberLayout')),
        urls: ['/'],
        subPages: [
            {
                alias: 'MemberOverview',
                component: lazy(() => import('./member/overview/MemberOverviewPage')),
                urls: [],
            },
            {
                alias: 'MemberRechargePoints',
                component: lazy(() => import('./member/rechargePoints/MemberRechargePointsPage')),
                urls: [],
            },
            {
                alias: 'MemberUpdateDetails',
                component: lazy(() => import('./member/updateDetails/MemberUpdateDetailsPage')),
                urls: [],
            },
            {
                alias: 'MemberBookingsAndTransactions',
                component: lazy(() => import('./member/bookingsAndTransactions/MemberBookingsAndTransactionsPage')),
                urls: [],
            },
            {
                alias: 'MemberRewardsAndOffers',
                component: lazy(() => import('./member/rewardsAndOffers/MemberRewardsAndOffersPage')),
                urls: [],
            },
            {
                alias: 'MemberWatchlist',
                component: lazy(() => import('./member/watchlist/MemberWatchlistPage')),
                urls: [],
            },
        ],
    },
    ErrorNotFound: {
        component: lazy(() => import('./404/NotFoundPage')),
        urls: ['/404'],
    },
}
